// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { all, takeLatest } from 'redux-saga/effects';
import { AdminTypes } from '../reducer/admin';
import { AuthTypes } from '../reducer/auth';
import { actionConnect, signIn, signOut, signUp } from './auth';
import {
  deleteData,
  deleteImageFromAlbum,
  sendEmail,
  updateData,
  uploadImageToAlbum,
} from './admin';

const authSagas = [
  takeLatest(AuthTypes.CONNECT, actionConnect),
  takeLatest(AuthTypes.LOGIN, signIn),
  takeLatest(AuthTypes.SIGNUP, signUp),
  takeLatest(AuthTypes.SIGN_OUT, signOut),
];

const adminSagas = [
  takeLatest(AdminTypes.UPDATE_DATA, updateData),
  takeLatest(AdminTypes.DELETE_DATA, deleteData),
  takeLatest(AdminTypes.SEND_EMAIL, sendEmail),
  takeLatest(AdminTypes.UPLOAD_IMAGE_TO_ALBUM, uploadImageToAlbum),
  takeLatest(AdminTypes.DELETE_IMAGE_FROM_ALBUM, deleteImageFromAlbum),
];

export default function* root() {
  yield all([...authSagas, ...adminSagas]);
}
